import Tr from "translations/Translations";

const isResponseValid = (response, setError) => {
    if (response && response.success !== false) {
        return true;
    } else {
        let errorSet = false;
        if (response.errors) {
            if (Array.isArray(response.errors)) {
                if (response.errors.length > 0) {
                    setError(response.errors[0])
                    errorSet = true;
                }
            } else {
                for (const key in response.errors) {
                    if (!response.errors.hasOwnProperty(key)) continue;
                    setError(response.errors[key]);
                    errorSet = true;
                    break;
                }
            }
        }
        if (!errorSet)
            setError(Tr('unknown_error_message'));
    }
    return false;
}

export default isResponseValid;